import { shuffleTake } from '../../../util/util';
import db from '../../databases';

export async function getRandomWords(count: number) {
    const words = await db.codenamesWordCollection.getAll();
    return shuffleTake(Object.keys(words), count);
}
